var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.98667 4.33333L8.66546 5.01222L2.1086 11.5556H1.44424V10.8911L7.98667 4.33333ZM10.5863 0C10.4058 0 10.218 0.0722222 10.0808 0.209444L8.75934 1.53111L11.4673 4.23944L12.7888 2.91778C13.0704 2.63611 13.0704 2.16667 12.7888 1.89944L11.099 0.209444C10.9546 0.065 10.7741 0 10.5863 0ZM7.98667 2.30389L0 10.2917V13H2.70796L10.6946 5.01222L7.98667 2.30389Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.ed46f10f.svg";
export { ForwardRef as ReactComponent };